import React from 'react';
import { AverageSatisfactionKPI, TotalStaffKPI, TopPerformersKPI } from './kpis';

interface KPISectionProps {
  branchId?: number;
  timeRange?: string;
  showLoading?: boolean;
  onError?: (error: Error) => void;
  compact?: boolean;
}

const KPIsSection: React.FC<KPISectionProps> = ({ 
  branchId,
  timeRange,
  showLoading = true,
  onError,
  compact = false 
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
      <AverageSatisfactionKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError} 
        showLoading={showLoading} 
        compact={compact} 
      />
      
      <TotalStaffKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError} 
        showLoading={showLoading} 
        compact={compact} 
      />
      
      <TopPerformersKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError} 
        showLoading={showLoading} 
        compact={compact} 
      />
    </div>
  );
};

export default KPIsSection;